import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import { UtilsTable } from '../../../../app/orussystem/utils/UtilTable';
import { GraficasStyles } from '../GraficasStyles';

const CardBasal = ({ rows, isLoad, paperStyle, lIcms, metabo }) => {
  const classes = GraficasStyles();

  return (
    <Paper>
      <Typography className={classes.title} color='primary'>Metabolismo Basal</Typography>

      <Grid container spacing={2}>
        {/* Columna para la tabla */}
        <Grid item xs={12} lg={12} style={{ padding: '0% 20%' }} >
          <Paper className={paperStyle} >
            <Table size="small">
              <TableHead>
                <TableRow alignItems="center">
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Metabolismo Basal</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoad ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">Cargando...</TableCell>
                  </TableRow>
                ) : (
                  rows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{UtilsTable().validateRowsTable(UtilsDate().formatDDMMMYYYY(new Date(row.datecreate)))}</TableCell>
                      <TableCell align="center">{UtilsTable().validateRowsTable(row.basal_metabolis
                      )}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CardBasal;
